import SDK from "../config";
import axios from "axios";
const baseUrl = SDK.BASE_URL;
class SubscriptionService {
  static async checkSubscriptionStatus(email) {
    try {
      const response = await axios.get(
        `${baseUrl}/subscription/status/${email}`
      );
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
  static async intializePayment(data) {
    try {
      const response = await axios.post(
        `${baseUrl}/subscription/initialize`,
        data
      );
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
  static async createSubscription(data) {
    try {
      const response = await axios.post(`${baseUrl}/subscription/create`, data);
      return response.data.data;
    } catch (error) {
      return "Payment failed";
    }
  }
}
export default SubscriptionService;
